// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  // Base styles shared by all variants
  baseShared: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },
  // Icon variant specific styles
  iconBase: {
    width: theme.other.spacing._16,
    height: theme.other.spacing._16,
    borderRadius: theme.other.spacing._16,
    padding: 0,
    minWidth: theme.other.spacing._16,
    minHeight: theme.other.spacing._16,
  },
  // Tag variant specific styles
  tagBase: {
    paddingLeft: theme.other.spacing._6,
    paddingRight: theme.other.spacing._6,
    paddingTop: theme.other.spacing._2,
    paddingBottom: theme.other.spacing._2,
    borderRadius: theme.defaultRadius,
    minHeight: 20,
    width: 'fit-content',
    gap: theme.other.spacing._4,
  },
  // Banner variant specific styles - full-width status bar
  bannerBase: {
    width: '100%',
    padding: 0,
    borderRadius: theme.radius.md, // Use theme border radius
    minHeight: 24,
    justifyContent: 'center',
  },
  // Status-based background colors
  actionRequired: {
    backgroundColor: theme.colors.red[3], // #DB3B3B - matches Figma exactly
  },
  warning: {
    backgroundColor: theme.colors.yellow[4], // Yellow - matches Figma
  },
  info: {
    backgroundColor: theme.colors.blue[3], // #4BEBE2 - theme blue
  },
  // Custom text styling to override color only (subhead-small matches Figma specs perfectly)
  alertText: {
    color: theme.white, // Default white text
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  // Alternative text color for warning and info statuses (black text on light backgrounds)
  altText: {
    color: theme.black, // Black text for warning and info statuses
  },
}));
